/* This example requires Tailwind CSS v2.0+ */
import { Fragment, PropsWithChildren } from 'react'
import { Dialog, Transition } from '@headlessui/react'

/**
 *
 */
export interface ModalProps {
  readonly open: boolean;

  /**
   *
   */
  readonly onClose: () => void;

  /**
   *
   */
  readonly onShowing?: () => void;

  /**
   *
   */
  readonly onHidden?: () => void;
}

/**
 *
 * @param props
 * @returns
 */
export const Modal: React.FC<PropsWithChildren<ModalProps>> = props => {
  return (
    <Transition.Root
      afterEnter={props.onShowing}
      show={props.open}
      as={Fragment}
    >
      <Dialog as="div" className="relative z-10" onClose={props.onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={props.onHidden}
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                {props.children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
